export default "__VITE_ASSET__DfrNIiWA__"